import { render, staticRenderFns } from "./Observations.vue?vue&type=template&id=03038043&scoped=true"
import script from "./Observations.vue?vue&type=script&lang=ts"
export * from "./Observations.vue?vue&type=script&lang=ts"
import style0 from "./Observations.vue?vue&type=style&index=0&id=03038043&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03038043",
  null
  
)

export default component.exports